"use client";

import { c as _c } from "react/compiler-runtime";
import MemesWaveQuickVoteTrigger from "@/components/brain/left-sidebar/waves/MemesWaveQuickVoteTrigger";
import { useMemesWaveFooterStats } from "@/hooks/useMemesWaveFooterStats";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { AnimatePresence, motion } from "framer-motion";
import { BoltIcon } from "@heroicons/react/24/solid";
import React from "react";
interface MemesWaveFooterProps {
  readonly collapsed?: boolean | undefined;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
}
const revealTransition = {
  duration: 0.22,
  ease: "easeOut"
} as const;
const MemesWaveFooter: React.FC<MemesWaveFooterProps> = t0 => {
  const $ = _c(16);
  const {
    collapsed: t1,
    onOpenQuickVote,
    onPrefetchQuickVote
  } = t0;
  const collapsed = t1 === undefined ? false : t1;
  const {
    isReady,
    uncastPower,
    unratedCount,
    votingLabel
  } = useMemesWaveFooterStats();
  let t2;
  if ($[0] !== onOpenQuickVote || $[1] !== unratedCount) {
    t2 = () => {
      if (unratedCount <= 0) {
        return;
      }
      onOpenQuickVote();
    };
    $[0] = onOpenQuickVote;
    $[1] = unratedCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleOpenQuickVote = t2;
  let t3;
  if ($[3] !== onPrefetchQuickVote || $[4] !== unratedCount) {
    t3 = () => {
      if (unratedCount <= 0) {
        return;
      }
      onPrefetchQuickVote?.();
    };
    $[3] = onPrefetchQuickVote;
    $[4] = unratedCount;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handlePrefetchQuickVote = t3;
  let t4;
  if ($[6] !== collapsed || $[7] !== handleOpenQuickVote || $[8] !== handlePrefetchQuickVote || $[9] !== isReady || $[10] !== uncastPower || $[11] !== unratedCount || $[12] !== votingLabel) {
    t4 = isReady && typeof uncastPower === "number" && <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={revealTransition} className={collapsed ? "tw-z-10 tw-flex tw-flex-shrink-0 tw-justify-center tw-px-2 tw-pb-2 tw-pt-1" : "tw-z-10 tw-flex-shrink-0 tw-bg-gradient-to-t tw-from-iron-950 tw-via-iron-950/95 tw-to-transparent tw-px-4 tw-pb-4 tw-pt-6"}>{collapsed ? <MemesWaveQuickVoteTrigger onOpenQuickVote={handleOpenQuickVote} onPrefetchQuickVote={handlePrefetchQuickVote} unratedCount={unratedCount} /> : <button type="button" aria-label={`Uncast Power, ${formatNumberWithCommas(uncastPower)} ${votingLabel ?? "Votes"}, ${unratedCount} left`} onClick={handleOpenQuickVote} onFocus={handlePrefetchQuickVote} onMouseEnter={handlePrefetchQuickVote} className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-4 tw-rounded-2xl tw-border tw-border-solid tw-border-primary-500/30 tw-bg-iron-900/95 tw-px-4 tw-py-3 tw-text-left tw-shadow-[0_18px_36px_rgba(0,0,0,0.28)] tw-backdrop-blur-sm tw-transition-colors tw-duration-300 desktop-hover:hover:tw-border-primary-400/40 desktop-hover:hover:tw-bg-iron-900"><div className="tw-min-w-0 tw-flex-1"><div className="tw-text-xs tw-font-medium tw-uppercase tw-tracking-[0.08em] tw-text-iron-500">Uncast Power</div><div className="tw-mt-1 tw-flex tw-items-center tw-gap-x-2 tw-text-primary-300"><BoltIcon className="tw-size-4 tw-flex-shrink-0" /><span className="tw-truncate tw-text-lg tw-font-semibold">{formatNumberWithCommas(uncastPower)}{votingLabel ? ` ${votingLabel}` : ""}</span></div></div><span className="tw-flex-shrink-0 tw-rounded-xl tw-border tw-border-solid tw-border-primary-500/20 tw-bg-primary-500/10 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-primary-300">{formatNumberWithCommas(unratedCount)} left</span></button>}</motion.div>;
    $[6] = collapsed;
    $[7] = handleOpenQuickVote;
    $[8] = handlePrefetchQuickVote;
    $[9] = isReady;
    $[10] = uncastPower;
    $[11] = unratedCount;
    $[12] = votingLabel;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default MemesWaveFooter;